export default {
  newConversation: 'New Conversation',
  leaveAMessage: 'Leave a Message',
  newConversationButtonAriaLabel: 'create a conversation',
  viewNewConversation: 'View New Conversation',
};
